import availableEventCategories from '@/helpers/availableEventCategoriesHelper'

export default {
    eventPayments: function() {
        const self = this

        let jobsAmount = 0

        self.event?.jobs?.forEach(item => {

            if (item.status <= 1) {
                jobsAmount += item.fee
            }
        })

        jobsAmount = jobsAmount * self.event.dates?.length


        return [
            {
                'description': 'Jobs',
                'amount': new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(jobsAmount)
            },
            {
                'description': 'Valor total com taxas',
                'amount': new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(self.event?.order?.finalAmount)
            }
        ]
    },
    eventCategory: function () {
      const self = this

      let result = 'Não informada'

      if (self.event.category) {
        result = availableEventCategories.filter(item => item.value === self.event.category)[0].label ?? 'Não informado'
      }

      return result
    }
}
